export default function (controller) {
  $(document).ready(function() {
    setTimeout(function() {
      // Legacy flash-style `.notice` only. Do not target `.alert`: Bootstrap alerts
      // are used for persistent in-page warnings (e.g. certifier credentials, Xero)
      // and would incorrectly fade out after a few seconds. Checklist reviewer
      // notes use `.alert` inside `.checklist-item` and were previously excluded
      // from a broader `.alert` rule for the same reason.
      $('.notice').fadeOut();
    }, 3000);
  })
}
